import axios from "axios";
import {
  DISCOUNT_UPDATE_REQUEST,
  DISCOUNT_UPDATE_SUCCESS,
  DISCOUNT_UPDATE_FAIL,
  DISCOUNT_GET_REQUEST,
  DISCOUNT_GET_SUCCESS,
  DISCOUNT_GET_FAIL,
} from "../constants/discountConstants";
import { DISCOUNT_API } from "../utils/apiConfig";

export const editDiscount = (discount, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DISCOUNT_UPDATE_REQUEST,
    });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        enctype: "multipart/form-data",
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      DISCOUNT_API + "/" + id,
      discount,
      config
    );

    dispatch(getDiscount(userInfo.slug));
    dispatch({
      type: DISCOUNT_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: DISCOUNT_UPDATE_FAIL,
      payload:
        error.response && error.response.data
          ? error.response.data
          : error.message,
    });
  }
};

export const getDiscount = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DISCOUNT_GET_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.get(DISCOUNT_API + "/" + id, config);

    dispatch({
      type: DISCOUNT_GET_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: DISCOUNT_GET_FAIL,
      payload:
        error.response && error.response.data
          ? error.response.data
          : error.message,
    });
  }
};
